import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { Navigator } from "../../../components/menu/navigator";
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { LogoutService } from 'src/app/services/logout/logout.service';

@Component({
  selector: 'app-authenticator-option',
  templateUrl: './authenticator-option.component.html',
  styleUrls: ['./authenticator-option.component.scss'],
})
export class AuthenticatorOptionComponent  implements OnInit {
  @ViewChild(IonContent, {static: false}) content: IonContent;

  @Input() customerId: any;
  @Input() callback: () => void;
  @Input() governmentId: any;
  @Input() onClose: () => void;
  @Input() isMFAFirst: any;
  
  error = null;
  public authenticatorOptionForm: FormGroup;
  public authOption: AbstractControl;
  public authOptionGroup;
  constructor(
    public successMessageService: SuccessMessageService,
    private navigator: Navigator,
    private appLinks: AppLinksService,
    private logoutService: LogoutService
  ) { }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.navigator.dismissAll();
    this.logoutService.onLogout({ reason: 'CLOSE_SIGNUP_STEP2' });
  }

  ngOnInit() {

    this.authenticatorOptionForm = new FormGroup({
			authOption: new FormControl({ value: '', disabled: false },[Validators.required])
		});

  }

  onSelectOption(data){
    this.authOptionGroup = data;
  }

  doNext(){
    if(this.authOptionGroup === 'SMS'){
      this.navigator.navigateTo('SmsLoginComponent', { forceModal: true }, { customerId: this.customerId, isMFAFirst: this.isMFAFirst, isRegistration: true, governmentId: this.governmentId, onClose: this.onClose });
    } else {
      this.navigator.navigateTo('AuthenticatorAppSetupComponent', { forceModal: true }, { customerId: this.customerId, isMFAFirst: this.isMFAFirst, isRegistration: true, governmentId: this.governmentId, onClose: this.onClose });
    }
  }

  closeModal = () => {
    const onClose = this.onClose;
    if (onClose) {
      this.navigator.dismiss();
      onClose();
    } else {
      this.navigator.dismiss();
    }
  }

  goToExternalLink(link) {
      this.appLinks.openMatchedExternalLinksPopover(link)
      return false;
  }

}
